import BlocksModel from '#model/BlocksModel'
import { useApiClient } from '#context/ApiContext'
import { useNotifications } from '#context/NotificationContext'
import { useInstanceOf } from 'eilmer-mvvm/react'

export default class BlocksViewModel {

  constructor(apiClient, notificationsProvider) {
    this.model = new BlocksModel(apiClient)
    this.notifications = notificationsProvider
    this.entity = new BlocksModel.Block()
    this.editing = false
    this.loadEntities()
  }

  async loadEntities() {
    try {
      this.entities = await this.model.getBlocks()
    } catch (err) {
      console.error(err)
      this.notifications.error(err.message)
    }
  }

  doEditEntity(entity) {
    this.entity = new BlocksModel.Block(entity)
    this.editing = true
  }

  doCancelEdit() {
    this.editing = false
  }

  async doSaveEntity(entity) {
    try {
      if (entity.isNew()) {
        const result = await this.model.createBlock(entity)
        this.editing = false
        this.loadEntities()
        return result
      } else {
        const result = await this.model.updateBlock(entity)
        this.editing = false
        this.loadEntities()
        return result
      }
    } catch (err) {
      this.notifications.error(err.message)
    }
  }

  async doDeleteEntity(entity) {
    if (await this.notifications.confirm('Are you sure you\'d like to delete this item?')) {
      try {
        const result = await this.model.deleteBlock(entity)
        this.loadEntities()
        return result
      } catch (err) {
        this.notifications.error(err.message)
      }
    }
  }

  get fields() {
    return [
      { key: 'block_id', label: "ID", _style: { width: '6%'}, _classes: 'bg-light text-dark' },
      { key: 'name', _style: { width: '25%'} },
      { key: 'description' },
      {
        key: 'actions',
        label: '',
        _style: { width: '70px' },
        filter: false
      }
    ]
  }

}

BlocksViewModel.useInstance = function() {
  return useInstanceOf(BlocksViewModel, useApiClient(), useNotifications())
}
